module.exports = "<td class=\"text-center placeholder\" colspan=\"{{num_cols}}\">\n  {{message}}\n</td>\n"